module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_1.8664e8a6.png";